import React, { Component } from 'react';
import axios from 'axios';
import Navbar from './NavbarScanner';
// import Sidebar from './SidebarScanner';
import Sidebar from "./Sidebar"
import LoaderRounded from "./LoaderRounded";
import { connect } from "react-redux";
import ReactPaginate from 'react-paginate';
import * as actions from "../actions/authAction";
import moment from 'moment';

class PrimeMemberList extends Component {
    constructor(props) {
        super(props);

        const storedRole = localStorage.getItem("role");
        const userRole = storedRole ? storedRole.toLowerCase() : "";

        const userCity = localStorage.getItem("city_name");
        const mobileNO = localStorage.getItem("mobile");
        // console.log("no",mobileNO)

        this.state = {
            allpaymentData: [],
            errors: [],
            yin_id: "",
            mobile: userRole === "coordinator" ? (mobileNO ?? "") : "",
            searchTitle: "",
            documentsPerPage: 10,
            selectedPage: 1,
            loader: true,
            showModalPopup: false,
            totalCount: 0,
            noOfPages: 0,
            city: userRole === "admin" ? (userCity ?? "") : "",
            cityList: [],
            exportLoader: false,
            userRole: userRole,
            userCity: userCity,
        }

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    handlePageChange(page) {
        const selectedPage = page.selected + 1;
        this.setState({ selectedPage });
        this.getData(selectedPage, this.state.yin_id, this.state.mobile, this.state.city);
    }

    handleCityChange(e) {
        // Use normalized role
        if (this.state.userRole === "coordinator") {
            return;
        }

        const city = e.target.value;
        this.setState({ city, selectedPage: 1 }, () => {
            this.getData(1, this.state.yin_id, this.state.mobile, this.state.city);
        });
    }

    componentDidMount() {

        this.getData(1, "", "", this.state.city || "");

        if (this.state.userRole !== "coordinator") {
            this.getCityList();
        }
    }

    // get subscription data 
    getData(page = 1, yin_id = "", mobile = "", city = "") {
        this.setState({ loader: true });

        const cleanCity = city && city !== "undefined" && city !== null ? city : "";
        const requestBody = {
            searchTitle: "",
            documentsPerPage: this.state.documentsPerPage || 10,
            page: page,
            yin_id: "",
            mobile: this.state.mobile,
            city: cleanCity
        };

        axios.post(process.env.REACT_APP_APIURL + `/subscription/getAllPGN`, requestBody)
            .then(res => {
                // console.log("response prime member", res)
                this.setState({
                    allpaymentData: res?.data?.data || [],
                    loader: false,
                    totalCount: res?.data?.count || 0,
                    noOfPages: res?.data?.noOfPages || 0
                });
            })
            .catch(err => {
                console.error("Error fetching data:", err);
                this.setState({ loader: false });
            });
    }

    getCityList() {
        axios.get(process.env.REACT_APP_APIURL + `/address/city`)
            .then(res => {
                // console.log("Response City List Data:", res.data);
                const citiesArray = res.data || [];

                this.setState({ cityList: citiesArray });
            })
            .catch(err => {
                console.error("Error fetching city list:", err);
            });
    }

    handleClear() {
        this.setState(
            {
                city: "",
                yin_id: "",
                mobile: this.state.userRole === "coordinator"
                    ? this.state.mobile
                    : "",
                searchTitle: "",
                selectedPage: 1
            },
            () => {
                // Reset ke baad original data fetch karo
                this.getData(1, "", this.state.mobile, "");
            }
        );
    }

    // handle excel export
    handleExport() {
        this.setState({ exportLoader: true });
        const cleanCity = this.state.city && this.state.city !== "undefined" ? this.state.city : "";
        const requestBody = {
            searchTitle: this.state.searchTitle,
            yin_id: this.state.yin_id,
            mobile: this.state.mobile,
            city: cleanCity
        };

        axios.post(process.env.REACT_APP_APIURL + `/subscription/exportExcelSubList`, requestBody)
            .then(res => {
                console.log("Export response", res);
                const fileUrl = res?.data?.data?.fileUrl;

                if (fileUrl) {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', 'Prime_Members_List.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    alert("Export failed: File URL not received.");
                }
                this.setState({ exportLoader: false });
            })
            .catch(err => {
                console.error("Error during export:", err);
                alert("An error occurred during export.");
                this.setState({ exportLoader: false });
            });
    }

    render() {
        const { allpaymentData, loader, noOfPages, cityList, city, exportLoader, userRole } = this.state;

        return (
            <>
                <Sidebar />
                <div className="main">
                    <div className="topbar">
                        <Navbar />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h2 className="divider-20">Prime Member List</h2>
                                    <div>
                                        <button
                                            className="btn btn-success me-2"
                                            onClick={this.handleExport}
                                            disabled={exportLoader}
                                        >
                                            {exportLoader ? <LoaderRounded /> : "Excel Export"}
                                        </button>
                                    </div>
                                </div>

                                <br />
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className="container">
                        <div className="row mb-3">
                            {/* Conditional Rendering using the normalized role */}
                            {userRole !== "coordinator" && (
                                <div className="col-md-4">
                                    <label htmlFor="cityFilter">Filter by City:</label>

                                    <div className="d-flex">
                                        <select
                                            id="cityFilter"
                                            className="form-control me-2"
                                            value={city}
                                            onChange={this.handleCityChange}
                                        >
                                            <option value="">All Cities</option>
                                            {cityList.map((cityObj, index) => (
                                                <option key={cityObj._id || index} value={cityObj.name}>
                                                    {cityObj.name}
                                                </option>
                                            ))}
                                        </select>

                                        <button
                                            className="btn btn-secondary"
                                            onClick={this.handleClear}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            )}

                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="table-responsive-sm">
                                    <table className="table table-bordered table-responsive">
                                        <thead>
                                            <tr>
                                                <th>Full Name</th>
                                                <th>Membership Plan</th>
                                                <th>Claimed Rewards</th>
                                                <th>City</th>
                                                <th>Mobile Number</th>
                                                <th>Subscription Status</th>
                                                <th>Transaction Status</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loader ? (
                                                <tr>
                                                    <td colSpan={7} className="text-center"><LoaderRounded /></td>
                                                </tr>
                                            ) : allpaymentData && allpaymentData.length > 0 ? (
                                                allpaymentData.map((item, index) => {
                                                    const rewards = item.claimedRewards || {};
                                                    const rewardList = [];
                                                    if (rewards.bag) rewardList.push("Bag");
                                                    if (rewards.bottle) rewardList.push("Bottle");
                                                    if (rewards.kit) rewardList.push("Kit");

                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.fullName}</td>
                                                            <td>{item.membershipPlan}</td>
                                                            <td>{rewardList.join(", ") || "-"}</td>
                                                            <td>{item.city}</td>
                                                            <td>{item.mobile}</td>
                                                            <td>{item.subscriptionstatus}</td>
                                                            <td>{item.transectionStatus}</td>
                                                            <td>{item.subscriptionStartDate ? moment(item.subscriptionStartDate).format("DD-MM-YYYY") : "-"}</td>
                                                            <td>{item.subscriptionEndDate ? moment(item.subscriptionEndDate).format("DD-MM-YYYY") : "-"}</td>
                                                        </tr>
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={7} className="text-center">No data found...</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/*Pagination */}
                            {noOfPages > 1 && (
                                <ReactPaginate
                                    nextLabel="Next"
                                    previousLabel="Previous"
                                    pageCount={noOfPages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    containerClassName="pagination"
                                    activeClassName="btn btn-primary"
                                    pageClassName="btn"
                                    previousClassName="btn"
                                    nextClassName="btn"
                                    onPageChange={this.handlePageChange}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (data) => dispatch(actions.loginSuccess(data)),
        mobile: (data) => dispatch(actions.adminmobile(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrimeMemberList);